export const sizeWithGigabyteAbbreviationText = "KdCG1b";
export const sizeWithMegabyteAbbreviationText = "I3Depd";
export const sizeWithKilobyteAbbreviationText = "z7jo";
export const sizeWithByteAbbreviationText = "eze7xc";
export default {sizeWithGigabyteAbbreviationText,sizeWithMegabyteAbbreviationText,sizeWithKilobyteAbbreviationText,sizeWithByteAbbreviationText};